import angular from 'angular';

class ExportServ {
    constructor() {}
    export (report, name, isLandscape) {
        $('<form/>', {
            action: '/generate',
            method: 'POST',
            enctype: 'multipart/form-data'
        }).append(
            $('<input/>', {
                name: 'report',
                value: report
            })
        ).append(
            $('<input/>', {
                name: 'name',
                value: name
            })
        ).append(
            $('<input/>', {
                name: 'isLandscape',
                value: isLandscape
            })
        ).appendTo('body').submit().remove();
    }
}

export default angular.module('services.export', [])
    .service('ExportServ', ExportServ)
    .name;



// WEBPACK FOOTER //
// ./project/services/export.js